// Generated from .\customExpression.g4 by ANTLR 4.7.2
// jshint ignore: start
import antlr4 from '../../utils/interop/antlr4';

var serializedATN = [
  '\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964',
  '\u0002#\u01a2\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004',
  '\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t',
  '\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004',
  '\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010',
  '\t\u0010\u0004\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013',
  '\u0004\u0014\t\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017',
  '\t\u0017\u0004\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a',
  '\u0004\u001b\t\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e',
  '\t\u001e\u0004\u001f\t\u001f\u0004 \t \u0004!\t!\u0004"\t"\u0003\u0002',
  '\u0003\u0002\u0003\u0003\u0003\u0003\u0003\u0004\u0003\u0004\u0003\u0005',
  '\u0003\u0005\u0003\u0005\u0003\u0005\u0003\u0005\u0003\u0005\u0003\u0005',
  '\u0003\u0005\u0003\u0005\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006',
  '\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0007\u0003\u0007',
  '\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003',
  '\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003\t\u0003\t\u0003',
  '\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003',
  '\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\n\u0003',
  '\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003',
  '\n\u0003\n\u0003\n\u0003\n\u0003\u000b\u0003\u000b\u0003\u000b\u0003',
  '\u000b\u0003\u000b\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\r\u0003',
  '\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\u000e\u0003\u000e\u0003\u000e',
  '\u0003\u000e\u0003\u000f\u0003\u000f\u0003\u000f\u0003\u000f\u0003\u000f',
  '\u0003\u0010\u0003\u0010\u0003\u0010\u0003\u0010\u0003\u0010\u0003\u0010',
  '\u0003\u0010\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011',
  '\u0003\u0011\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0012',
  '\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0013',
  '\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013',
  '\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013',
  '\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013',
  '\u0003\u0013\u0003\u0014\u0003\u0014\u0003\u0014\u0003\u0014\u0003\u0014',
  '\u0003\u0015\u0003\u0015\u0003\u0015\u0003\u0015\u0003\u0016\u0003\u0016',
  '\u0003\u0016\u0003\u0016\u0003\u0016\u0003\u0016\u0003\u0016\u0003\u0016',
  '\u0003\u0016\u0003\u0016\u0003\u0017\u0003\u0017\u0003\u0017\u0003\u0018',
  '\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0018',
  '\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0019\u0003\u0019\u0003\u0019',
  '\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019',
  '\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a',
  '\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a',
  '\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b',
  '\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b',
  '\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001c',
  '\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c',
  '\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c',
  '\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c',
  '\u0003\u001c\u0003\u001d\u0006\u001d\u012e\n\u001d\r\u001d\u000e\u001d',
  '\u012f\u0003\u001d\u0003\u001d\u0003\u001e\u0003\u001e\u0003\u001e\u0003',
  '\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003',
  '\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003',
  '\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003',
  '\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003',
  '\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003',
  '\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003',
  '\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003',
  '\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003',
  '\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003',
  '\u001e\u0003\u001e\u0005\u001e\u016f\n\u001e\u0003\u001f\u0003\u001f',
  '\u0007\u001f\u0173\n\u001f\f\u001f\u000e\u001f\u0176\u000b\u001f\u0003',
  ' \u0006 \u0179\n \r \u000e \u017a\u0003 \u0003 \u0006 \u017f\n \r \u000e',
  ' \u0180\u0005 \u0183\n \u0003!\u0003!\u0003!\u0003!\u0006!\u0189\n!',
  '\r!\u000e!\u018a\u0003"\u0003"\u0003"\u0003"\u0007"\u0191\n"\f',
  '"\u000e"\u0194\u000b"\u0003"\u0003"\u0003"\u0003"\u0003"\u0007',
  '"\u019b\n"\f"\u000e"\u019e\u000b"\u0003"\u0005"\u01a1\n"\u0002',
  '\u0002#\u0003\u0003\u0005\u0004\u0007\u0005\t\u0006\u000b\u0007\r\b',
  '\u000f\t\u0011\n\u0013\u000b\u0015\f\u0017\r\u0019\u000e\u001b\u000f',
  "\u001d\u0010\u001f\u0011!\u0012#\u0013%\u0014\'\u0015)\u0016+\u0017",
  '-\u0018/\u00191\u001a3\u001b5\u001c7\u001d9\u001e;\u001f= ?!A"C#\u0003',
  '\u0002\t\u0004\u0002\u000b\u000b""\u0006\u0002<<C\\aac|\u0007\u0002',
  '/02<C\\aac|\u0003\u00022;\u0005\u00022;CHch\u0004\u0002$$^^\u0004\u0002',
  '))^^\u0002\u01b2\u0002\u0003\u0003\u0002\u0002\u0002\u0002\u0005\u0003',
  '\u0002\u0002\u0002\u0002\u0007\u0003\u0002\u0002\u0002\u0002\t\u0003',
  '\u0002\u0002\u0002\u0002\u000b\u0003\u0002\u0002\u0002\u0002\r\u0003',
  '\u0002\u0002\u0002\u0002\u000f\u0003\u0002\u0002\u0002\u0002\u0011\u0003',
  '\u0002\u0002\u0002\u0002\u0013\u0003\u0002\u0002\u0002\u0002\u0015\u0003',
  '\u0002\u0002\u0002\u0002\u0017\u0003\u0002\u0002\u0002\u0002\u0019\u0003',
  '\u0002\u0002\u0002\u0002\u001b\u0003\u0002\u0002\u0002\u0002\u001d\u0003',
  '\u0002\u0002\u0002\u0002\u001f\u0003\u0002\u0002\u0002\u0002!\u0003',
  '\u0002\u0002\u0002\u0002#\u0003\u0002\u0002\u0002\u0002%\u0003\u0002',
  "\u0002\u0002\u0002\'\u0003\u0002\u0002\u0002\u0002)\u0003\u0002\u0002",
  '\u0002\u0002+\u0003\u0002\u0002\u0002\u0002-\u0003\u0002\u0002\u0002',
  '\u0002/\u0003\u0002\u0002\u0002\u00021\u0003\u0002\u0002\u0002\u0002',
  '3\u0003\u0002\u0002\u0002\u00025\u0003\u0002\u0002\u0002\u00027\u0003',
  '\u0002\u0002\u0002\u00029\u0003\u0002\u0002\u0002\u0002;\u0003\u0002',
  '\u0002\u0002\u0002=\u0003\u0002\u0002\u0002\u0002?\u0003\u0002\u0002',
  '\u0002\u0002A\u0003\u0002\u0002\u0002\u0002C\u0003\u0002\u0002\u0002',
  '\u0003E\u0003\u0002\u0002\u0002\u0005G\u0003\u0002\u0002\u0002\u0007',
  'I\u0003\u0002\u0002\u0002\tK\u0003\u0002\u0002\u0002\u000bT\u0003\u0002',
  '\u0002\u0002\r\\\u0003\u0002\u0002\u0002\u000f^\u0003\u0002\u0002\u0002',
  '\u0011m\u0003\u0002\u0002\u0002\u0013\u0080\u0003\u0002\u0002\u0002',
  '\u0015\u008e\u0003\u0002\u0002\u0002\u0017\u0093\u0003\u0002\u0002\u0002',
  '\u0019\u0098\u0003\u0002\u0002\u0002\u001b\u009e\u0003\u0002\u0002\u0002',
  '\u001d\u00a2\u0003\u0002\u0002\u0002\u001f\u00a7\u0003\u0002\u0002\u0002',
  '!\u00ae\u0003\u0002\u0002\u0002#\u00b4\u0003\u0002\u0002\u0002%\u00be',
  "\u0003\u0002\u0002\u0002\'\u00d2\u0003\u0002\u0002\u0002)\u00d7\u0003",
  '\u0002\u0002\u0002+\u00db\u0003\u0002\u0002\u0002-\u00e5\u0003\u0002',
  '\u0002\u0002/\u00e8\u0003\u0002\u0002\u00021\u00f2\u0003\u0002\u0002',
  '\u00023\u00fb\u0003\u0002\u0002\u00025\u0107\u0003\u0002\u0002\u0002',
  '7\u0118\u0003\u0002\u0002\u00029\u012d\u0003\u0002\u0002\u0002;\u016e',
  '\u0003\u0002\u0002\u0002=\u0170\u0003\u0002\u0002\u0002?\u0182\u0003',
  '\u0002\u0002\u0002A\u0184\u0003\u0002\u0002\u0002C\u01a0\u0003\u0002',
  '\u0002\u0002EF\u0007-\u0002\u0002F\u0004\u0003\u0002\u0002\u0002GH\u0007',
  '*\u0002\u0002H\u0006\u0003\u0002\u0002\u0002IJ\u0007+\u0002\u0002J\b',
  '\u0003\u0002\u0002\u0002KL\u0007T\u0002\u0002LM\u0007k\u0002\u0002M',
  'N\u0007i\u0002\u0002NO\u0007j\u0002\u0002OP\u0007v\u0002\u0002PQ\u0007',
  'R\u0002\u0002QR\u0007c\u0002\u0002RS\u0007f\u0002\u0002S\n\u0003\u0002',
  '\u0002\u0002TU\u0007N\u0002\u0002UV\u0007g\u0002\u0002VW\u0007h\u0002',
  '\u0002WX\u0007v\u0002\u0002XY\u0007R\u0002\u0002YZ\u0007c\u0002\u0002',
  'Z[\u0007f\u0002\u0002[\f\u0003\u0002\u0002\u0002\\]\u0007.\u0002\u0002',
  ']\u000e\u0003\u0002\u0002\u0002^_\u0007F\u0002\u0002_`\u0007c\u0002',
  '\u0002`a\u0007v\u0002\u0002ab\u0007g\u0002\u0002bc\u0007V\u0002\u0002',
  'cd\u0007k\u0002\u0002de\u0007o\u0002\u0002ef\u0007g\u0002\u0002fg\u0007',
  'H\u0002\u0002gh\u0007q\u0002\u0002hi\u0007t\u0002\u0002ij\u0007o\u0002',
  '\u0002jk\u0007c\u0002\u0002kl\u0007v\u0002\u0002l\u0010\u0003\u0002',
  '\u0002\u0002mn\u0007E\u0002\u0002no\u0007q\u0002\u0002op\u0007p\u0002',
  '\u0002pq\u0007x\u0002\u0002qr\u0007g\u0002\u0002rs\u0007t\u0002\u0002',
  'st\u0007v\u0002\u0002tu\u0007U\u0002\u0002uv\u0007k\u0002\u0002vw\u0007',
  'f\u0002\u0002wx\u0007V\u0002\u0002xy\u0007q\u0002\u0002yz\u0007U\u0002',
  '\u0002z{\u0007v\u0002\u0002{|\u0007t\u0002\u0002|}\u0007k\u0002\u0002',
  '}~\u0007p\u0002\u0002~\u007f\u0007i\u0002\u0002\u007f\u0012\u0003\u0002',
  '\u0002\u0002\u0080\u0081\u0007T\u0002\u0002\u0081\u0082\u0007g\u0002',
  '\u0002\u0082\u0083\u0007r\u0002\u0002\u0083\u0084\u0007n\u0002\u0002',
  '\u0084\u0085\u0007c\u0002\u0002\u0085\u0086\u0007e\u0002\u0002\u0086',
  '\u0087\u0007g\u0002\u0002\u0087\u0088\u0007U\u0002\u0002\u0088\u0089',
  '\u0007v\u0002\u0002\u0089\u008a\u0007t\u0002\u0002\u008a\u008b\u0007',
  'k\u0002\u0002\u008b\u008c\u0007p\u0002\u0002\u008c\u008d\u0007i\u0002',
  '\u0002\u008d\u0014\u0003\u0002\u0002\u0002\u008e\u008f\u0007Y\u0002',
  '\u0002\u008f\u0090\u0007q\u0002\u0002\u0090\u0091\u0007t\u0002\u0002',
  '\u0091\u0092\u0007f\u0002\u0002\u0092\u0016\u0003\u0002\u0002\u0002',
  '\u0093\u0094\u0007N\u0002\u0002\u0094\u0095\u0007g\u0002\u0002\u0095',
  '\u0096\u0007h\u0002\u0002\u0096\u0097\u0007v\u0002\u0002\u0097\u0018',
  '\u0003\u0002\u0002\u0002\u0098\u0099\u0007T\u0002\u0002\u0099\u009a',
  '\u0007k\u0002\u0002\u009a\u009b\u0007i\u0002\u0002\u009b\u009c\u0007',
  'j\u0002\u0002\u009c\u009d\u0007v\u0002\u0002\u009d\u001a\u0003\u0002',
  '\u0002\u0002\u009e\u009f\u0007O\u0002\u0002\u009f\u00a0\u0007k\u0002',
  '\u0002\u00a0\u00a1\u0007f\u0002\u0002\u00a1\u001c\u0003\u0002\u0002',
  '\u0002\u00a2\u00a3\u0007E\u0002\u0002\u00a3\u00a4\u0007T\u0002\u0002',
  '\u00a4\u00a5\u0007N\u0002\u0002\u00a5\u00a6\u0007H\u0002\u0002\u00a6',
  '\u001e\u0003\u0002\u0002\u0002\u00a7\u00a8\u0007D\u0002\u0002\u00a8',
  '\u00a9\u0007k\u0002\u0002\u00a9\u00aa\u0007v\u0002\u0002\u00aa\u00ab',
  '\u0007C\u0002\u0002\u00ab\u00ac\u0007p\u0002\u0002\u00ac\u00ad\u0007',
  'f\u0002\u0002\u00ad \u0003\u0002\u0002\u0002\u00ae\u00af\u0007D\u0002',
  '\u0002\u00af\u00b0\u0007k\u0002\u0002\u00b0\u00b1\u0007v\u0002\u0002',
  '\u00b1\u00b2\u0007Q\u0002\u0002\u00b2\u00b3\u0007t\u0002\u0002\u00b3',
  '"\u0003\u0002\u0002\u0002\u00b4\u00b5\u0007T\u0002\u0002\u00b5\u00b6',
  '\u0007c\u0002\u0002\u00b6\u00b7\u0007p\u0002\u0002\u00b7\u00b8\u0007',
  'f\u0002\u0002\u00b8\u00b9\u0007q\u0002\u0002\u00b9\u00ba\u0007o\u0002',
  '\u0002\u00ba\u00bb\u0007P\u0002\u0002\u00bb\u00bc\u0007w\u0002\u0002',
  '\u00bc\u00bd\u0007o\u0002\u0002\u00bd$\u0003\u0002\u0002\u0002\u00be',
  '\u00bf\u0007E\u0002\u0002\u00bf\u00c0\u0007q\u0002\u0002\u00c0\u00c1',
  '\u0007p\u0002\u0002\u00c1\u00c2\u0007x\u0002\u0002\u00c2\u00c3\u0007',
  'g\u0002\u0002\u00c3\u00c4\u0007t\u0002\u0002\u00c4\u00c5\u0007v\u0002',
  '\u0002\u00c5\u00c6\u0007U\u0002\u0002\u00c6\u00c7\u0007v\u0002\u0002',
  '\u00c7\u00c8\u0007t\u0002\u0002\u00c8\u00c9\u0007k\u0002\u0002\u00c9',
  '\u00ca\u0007p\u0002\u0002\u00ca\u00cb\u0007i\u0002\u0002\u00cb\u00cc',
  '\u0007V\u0002\u0002\u00cc\u00cd\u0007q\u0002\u0002\u00cd\u00ce\u0007',
  'I\u0002\u0002\u00ce\u00cf\u0007w\u0002\u0002\u00cf\u00d0\u0007k\u0002',
  '\u0002\u00d0\u00d1\u0007f\u0002\u0002\u00d1&\u0003\u0002\u0002\u0002',
  '\u00d2\u00d3\u0007P\u0002\u0002\u00d3\u00d4\u0007w\u0002\u0002\u00d4',
  '\u00d5\u0007n\u0002\u0002\u00d5\u00d6\u0007n\u0002\u0002\u00d6(\u0003',
  '\u0002\u0002\u0002\u00d7\u00d8\u0007K\u0002\u0002\u00d8\u00d9\u0007',
  'K\u0002\u0002\u00d9\u00da\u0007H\u0002\u0002\u00da*\u0003\u0002\u0002',
  '\u0002\u00db\u00dc\u0007K\u0002\u0002\u00dc\u00dd\u0007u\u0002\u0002',
  '\u00dd\u00de\u0007R\u0002\u0002\u00de\u00df\u0007t\u0002\u0002\u00df',
  '\u00e0\u0007g\u0002\u0002\u00e0\u00e1\u0007u\u0002\u0002\u00e1\u00e2',
  '\u0007g\u0002\u0002\u00e2\u00e3\u0007p\u0002\u0002\u00e3\u00e4\u0007',
  'v\u0002\u0002\u00e4,\u0003\u0002\u0002\u0002\u00e5\u00e6\u0007G\u0002',
  '\u0002\u00e6\u00e7\u0007s\u0002\u0002\u00e7.\u0003\u0002\u0002\u0002',
  '\u00e8\u00e9\u0007P\u0002\u0002\u00e9\u00ea\u0007q\u0002\u0002\u00ea',
  '\u00eb\u0007v\u0002\u0002\u00eb\u00ec\u0007G\u0002\u0002\u00ec\u00ed',
  '\u0007s\u0002\u0002\u00ed\u00ee\u0007w\u0002\u0002\u00ee\u00ef\u0007',
  'c\u0002\u0002\u00ef\u00f0\u0007n\u0002\u0002\u00f0\u00f1\u0007u\u0002',
  '\u0002\u00f10\u0003\u0002\u0002\u0002\u00f2\u00f3\u0007N\u0002\u0002',
  '\u00f3\u00f4\u0007g\u0002\u0002\u00f4\u00f5\u0007u\u0002\u0002\u00f5',
  '\u00f6\u0007u\u0002\u0002\u00f6\u00f7\u0007V\u0002\u0002\u00f7\u00f8',
  '\u0007j\u0002\u0002\u00f8\u00f9\u0007c\u0002\u0002\u00f9\u00fa\u0007',
  'p\u0002\u0002\u00fa2\u0003\u0002\u0002\u0002\u00fb\u00fc\u0007I\u0002',
  '\u0002\u00fc\u00fd\u0007t\u0002\u0002\u00fd\u00fe\u0007g\u0002\u0002',
  '\u00fe\u00ff\u0007c\u0002\u0002\u00ff\u0100\u0007v\u0002\u0002\u0100',
  '\u0101\u0007g\u0002\u0002\u0101\u0102\u0007t\u0002\u0002\u0102\u0103',
  '\u0007V\u0002\u0002\u0103\u0104\u0007j\u0002\u0002\u0104\u0105\u0007',
  'c\u0002\u0002\u0105\u0106\u0007p\u0002\u0002\u01064\u0003\u0002\u0002',
  '\u0002\u0107\u0108\u0007N\u0002\u0002\u0108\u0109\u0007g\u0002\u0002',
  '\u0109\u010a\u0007u\u0002\u0002\u010a\u010b\u0007u\u0002\u0002\u010b',
  '\u010c\u0007V\u0002\u0002\u010c\u010d\u0007j\u0002\u0002\u010d\u010e',
  '\u0007c\u0002\u0002\u010e\u010f\u0007p\u0002\u0002\u010f\u0110\u0007',
  'Q\u0002\u0002\u0110\u0111\u0007t\u0002\u0002\u0111\u0112\u0007G\u0002',
  '\u0002\u0112\u0113\u0007s\u0002\u0002\u0113\u0114\u0007w\u0002\u0002',
  '\u0114\u0115\u0007c\u0002\u0002\u0115\u0116\u0007n\u0002\u0002\u0116',
  '\u0117\u0007u\u0002\u0002\u01176\u0003\u0002\u0002\u0002\u0118\u0119',
  '\u0007I\u0002\u0002\u0119\u011a\u0007t\u0002\u0002\u011a\u011b\u0007',
  'g\u0002\u0002\u011b\u011c\u0007c\u0002\u0002\u011c\u011d\u0007v\u0002',
  '\u0002\u011d\u011e\u0007g\u0002\u0002\u011e\u011f\u0007t\u0002\u0002',
  '\u011f\u0120\u0007V\u0002\u0002\u0120\u0121\u0007j\u0002\u0002\u0121',
  '\u0122\u0007c\u0002\u0002\u0122\u0123\u0007p\u0002\u0002\u0123\u0124',
  '\u0007Q\u0002\u0002\u0124\u0125\u0007t\u0002\u0002\u0125\u0126\u0007',
  'G\u0002\u0002\u0126\u0127\u0007s\u0002\u0002\u0127\u0128\u0007w\u0002',
  '\u0002\u0128\u0129\u0007c\u0002\u0002\u0129\u012a\u0007n\u0002\u0002',
  '\u012a\u012b\u0007u\u0002\u0002\u012b8\u0003\u0002\u0002\u0002\u012c',
  '\u012e\t\u0002\u0002\u0002\u012d\u012c\u0003\u0002\u0002\u0002\u012e',
  '\u012f\u0003\u0002\u0002\u0002\u012f\u012d\u0003\u0002\u0002\u0002\u012f',
  '\u0130\u0003\u0002\u0002\u0002\u0130\u0131\u0003\u0002\u0002\u0002\u0131',
  '\u0132\b\u001d\u0002\u0002\u0132:\u0003\u0002\u0002\u0002\u0133\u0134',
  '\u0007W\u0002\u0002\u0134\u0135\u0007r\u0002\u0002\u0135\u0136\u0007',
  'r\u0002\u0002\u0136\u0137\u0007g\u0002\u0002\u0137\u0138\u0007t\u0002',
  '\u0002\u0138\u0139\u0007E\u0002\u0002\u0139\u013a\u0007c\u0002\u0002',
  '\u013a\u013b\u0007u\u0002\u0002\u013b\u016f\u0007g\u0002\u0002\u013c',
  '\u013d\u0007N\u0002\u0002\u013d\u013e\u0007q\u0002\u0002\u013e\u013f',
  '\u0007y\u0002\u0002\u013f\u0140\u0007g\u0002\u0002\u0140\u0141\u0007',
  't\u0002\u0002\u0141\u0142\u0007E\u0002\u0002\u0142\u0143\u0007c\u0002',
  '\u0002\u0143\u0144\u0007u\u0002\u0002\u0144\u016f\u0007g\u0002\u0002',
  '\u0145\u0146\u0007R\u0002\u0002\u0146\u0147\u0007t\u0002\u0002\u0147',
  '\u0148\u0007q\u0002\u0002\u0148\u0149\u0007r\u0002\u0002\u0149\u014a',
  '\u0007g\u0002\u0002\u014a\u014b\u0007t\u0002\u0002\u014b\u014c\u0007',
  'E\u0002\u0002\u014c\u014d\u0007c\u0002\u0002\u014d\u014e\u0007u\u0002',
  '\u0002\u014e\u016f\u0007g\u0002\u0002\u014f\u0150\u0007N\u0002\u0002',
  '\u0150\u0151\u0007V\u0002\u0002\u0151\u0152\u0007t\u0002\u0002\u0152',
  '\u0153\u0007k\u0002\u0002\u0153\u016f\u0007o\u0002\u0002\u0154\u0155',
  '\u0007T\u0002\u0002\u0155\u0156\u0007V\u0002\u0002\u0156\u0157\u0007',
  't\u0002\u0002\u0157\u0158\u0007k\u0002\u0002\u0158\u016f\u0007o\u0002',
  '\u0002\u0159\u015a\u0007V\u0002\u0002\u015a\u015b\u0007t\u0002\u0002',
  '\u015b\u015c\u0007k\u0002\u0002\u015c\u016f\u0007o\u0002\u0002\u015d',
  '\u015e\u0007G\u0002\u0002\u015e\u015f\u0007u\u0002\u0002\u015f\u0160',
  '\u0007e\u0002\u0002\u0160\u0161\u0007c\u0002\u0002\u0161\u0162\u0007',
  'r\u0002\u0002\u0162\u0163\u0007g\u0002\u0002\u0163\u0164\u0007F\u0002',
  '\u0002\u0164\u0165\u0007P\u0002\u0002\u0165\u0166\u0007E\u0002\u0002',
  '\u0166\u0167\u0007q\u0002\u0002\u0167\u0168\u0007o\u0002\u0002\u0168',
  '\u0169\u0007r\u0002\u0002\u0169\u016a\u0007q\u0002\u0002\u016a\u016b',
  '\u0007p\u0002\u0002\u016b\u016c\u0007g\u0002\u0002\u016c\u016d\u0007',
  'p\u0002\u0002\u016d\u016f\u0007v\u0002\u0002\u016e\u0133\u0003\u0002',
  '\u0002\u0002\u016e\u013c\u0003\u0002\u0002\u0002\u016e\u0145\u0003\u0002',
  '\u0002\u0002\u016e\u014f\u0003\u0002\u0002\u0002\u016e\u0154\u0003\u0002',
  '\u0002\u0002\u016e\u0159\u0003\u0002\u0002\u0002\u016e\u015d\u0003\u0002',
  '\u0002\u0002\u016f<\u0003\u0002\u0002\u0002\u0170\u0174\t\u0003\u0002',
  '\u0002\u0171\u0173\t\u0004\u0002\u0002\u0172\u0171\u0003\u0002\u0002',
  '\u0002\u0173\u0176\u0003\u0002\u0002\u0002\u0174\u0172\u0003\u0002\u0002',
  '\u0002\u0174\u0175\u0003\u0002\u0002\u0002\u0175>\u0003\u0002\u0002',
  '\u0002\u0176\u0174\u0003\u0002\u0002\u0002\u0177\u0179\t\u0005\u0002',
  '\u0002\u0178\u0177\u0003\u0002\u0002\u0002\u0179\u017a\u0003\u0002\u0002',
  '\u0002\u017a\u0178\u0003\u0002\u0002\u0002\u017a\u017b\u0003\u0002\u0002',
  '\u0002\u017b\u0183\u0003\u0002\u0002\u0002\u017c\u017e\u0007/\u0002',
  '\u0002\u017d\u017f\t\u0005\u0002\u0002\u017e\u017d\u0003\u0002\u0002',
  '\u0002\u017f\u0180\u0003\u0002\u0002\u0002\u0180\u017e\u0003\u0002\u0002',
  '\u0002\u0180\u0181\u0003\u0002\u0002\u0002\u0181\u0183\u0003\u0002\u0002',
  '\u0002\u0182\u0178\u0003\u0002\u0002\u0002\u0182\u017c\u0003\u0002\u0002',
  '\u0002\u0183@\u0003\u0002\u0002\u0002\u0184\u0185\u00072\u0002\u0002',
  '\u0185\u0186\u0007z\u0002\u0002\u0186\u0188\u0003\u0002\u0002\u0002',
  '\u0187\u0189\t\u0006\u0002\u0002\u0188\u0187\u0003\u0002\u0002\u0002',
  '\u0189\u018a\u0003\u0002\u0002\u0002\u018a\u0188\u0003\u0002\u0002\u0002',
  '\u018a\u018b\u0003\u0002\u0002\u0002\u018bB\u0003\u0002\u0002\u0002',
  '\u018c\u0192\u0007$\u0002\u0002\u018d\u0191\n\u0007\u0002\u0002\u018e',
  '\u018f\u0007^\u0002\u0002\u018f\u0191\t\u0007\u0002\u0002\u0190\u018d',
  '\u0003\u0002\u0002\u0002\u0190\u018e\u0003\u0002\u0002\u0002\u0191\u0194',
  '\u0003\u0002\u0002\u0002\u0192\u0190\u0003\u0002\u0002\u0002\u0192\u0193',
  '\u0003\u0002\u0002\u0002\u0193\u0195\u0003\u0002\u0002\u0002\u0194\u0192',
  '\u0003\u0002\u0002\u0002\u0195\u01a1\u0007$\u0002\u0002\u0196\u019c',
  '\u0007)\u0002\u0002\u0197\u019b\n\b\u0002\u0002\u0198\u0199\u0007^\u0002',
  '\u0002\u0199\u019b\t\b\u0002\u0002\u019a\u0197\u0003\u0002\u0002\u0002',
  '\u019a\u0198\u0003\u0002\u0002\u0002\u019b\u019e\u0003\u0002\u0002\u0002',
  '\u019c\u019a\u0003\u0002\u0002\u0002\u019c\u019d\u0003\u0002\u0002\u0002',
  '\u019d\u019f\u0003\u0002\u0002\u0002\u019e\u019c\u0003\u0002\u0002\u0002',
  '\u019f\u01a1\u0007)\u0002\u0002\u01a0\u018c\u0003\u0002\u0002\u0002',
  '\u01a0\u0196\u0003\u0002\u0002\u0002\u01a1D\u0003\u0002\u0002\u0002',
  '\u000f\u0002\u012f\u016e\u0174\u017a\u0180\u0182\u018a\u0190\u0192\u019a',
  '\u019c\u01a0\u0003\b\u0002\u0002',
].join('');

var atn = new antlr4.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map(function (ds, index) {
  return new antlr4.DFA(ds, index);
});

class customExpressionLexer extends antlr4.Lexer {
  constructor(input) {
    super(input);
    this._interp = new antlr4.LexerATNSimulator(
      this,
      atn,
      decisionsToDFA,
      new antlr4.PredictionContextCache(),
    );
  }

  get atn() {
    return atn;
  }
}

customExpressionLexer.EOF = antlr4.Token.EOF;
customExpressionLexer.T__0 = 1;
customExpressionLexer.T__1 = 2;
customExpressionLexer.T__2 = 3;
customExpressionLexer.T__3 = 4;
customExpressionLexer.T__4 = 5;
customExpressionLexer.T__5 = 6;
customExpressionLexer.T__6 = 7;
customExpressionLexer.T__7 = 8;
customExpressionLexer.T__8 = 9;
customExpressionLexer.T__9 = 10;
customExpressionLexer.T__10 = 11;
customExpressionLexer.T__11 = 12;
customExpressionLexer.T__12 = 13;
customExpressionLexer.T__13 = 14;
customExpressionLexer.T__14 = 15;
customExpressionLexer.T__15 = 16;
customExpressionLexer.T__16 = 17;
customExpressionLexer.T__17 = 18;
customExpressionLexer.T__18 = 19;
customExpressionLexer.T__19 = 20;
customExpressionLexer.T__20 = 21;
customExpressionLexer.T__21 = 22;
customExpressionLexer.T__22 = 23;
customExpressionLexer.T__23 = 24;
customExpressionLexer.T__24 = 25;
customExpressionLexer.T__25 = 26;
customExpressionLexer.T__26 = 27;
customExpressionLexer.WS = 28;
customExpressionLexer.UnaryStringFunctionName = 29;
customExpressionLexer.QNAME = 30;
customExpressionLexer.NUMBER = 31;
customExpressionLexer.HEX = 32;
customExpressionLexer.STRING = 33;

customExpressionLexer.channelNames = ['DEFAULT_TOKEN_CHANNEL', 'HIDDEN'];

customExpressionLexer.modeNames = ['DEFAULT_MODE'];

customExpressionLexer.literalNames = [
  null,
  "'+'",
  "'('",
  "')'",
  "'RightPad'",
  "'LeftPad'",
  "','",
  "'DateTimeFormat'",
  "'ConvertSidToString'",
  "'ReplaceString'",
  "'Word'",
  "'Left'",
  "'Right'",
  "'Mid'",
  "'CRLF'",
  "'BitAnd'",
  "'BitOr'",
  "'RandomNum'",
  "'ConvertStringToGuid'",
  "'Null'",
  "'IIF'",
  "'IsPresent'",
  "'Eq'",
  "'NotEquals'",
  "'LessThan'",
  "'GreaterThan'",
  "'LessThanOrEquals'",
  "'GreaterThanOrEquals'",
];

customExpressionLexer.symbolicNames = [
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  'WS',
  'UnaryStringFunctionName',
  'QNAME',
  'NUMBER',
  'HEX',
  'STRING',
];

customExpressionLexer.ruleNames = [
  'T__0',
  'T__1',
  'T__2',
  'T__3',
  'T__4',
  'T__5',
  'T__6',
  'T__7',
  'T__8',
  'T__9',
  'T__10',
  'T__11',
  'T__12',
  'T__13',
  'T__14',
  'T__15',
  'T__16',
  'T__17',
  'T__18',
  'T__19',
  'T__20',
  'T__21',
  'T__22',
  'T__23',
  'T__24',
  'T__25',
  'T__26',
  'WS',
  'UnaryStringFunctionName',
  'QNAME',
  'NUMBER',
  'HEX',
  'STRING',
];

customExpressionLexer.grammarFileName = 'customExpression.g4';

export default customExpressionLexer;
export { customExpressionLexer };
